export default {
  business: 'Per il tuo business',
  'get-inspired': 'Lasciati ispirare',
  'how-to': 'Come si fa',
  news: 'Le novità',
  printstories: 'Print stories',
  highlights: 'Highlights',
  'business-growth': 'Business growth',
}
